/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const discoplanet: CommunityData = {
  code: "discoplanet",
  inviteCode: "grape",
  name: "Disco Planet",
  thumbnail: "/assets/customizations/discoPlanet/dp-thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/dis-161`,
  socials: {
    instagramLink: "https://instagram.com/discoplanetcph?igshid=YmMyMTA2M2Y=",
    soundcloudLink: "",
  },
  styles: {
    global: {
      counterColor: "#3C404B",
      alternativeLogo: {
        src: "/assets/customizations/discoPlanet/logo.svg",
        styles: "w-[116px]",
      },
      logo: {
        src: "/assets/customizations/discoPlanet/logo.svg",
        styles: "w-[130px] h-[114px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#414255",
      asideStyles: "",
      asideBg: "#BEC2FF",
      contentBg: "#F4F5FF",
      contentBoxShadow: "shadow-[0px_4px_4px_rgba(0,0,0,0.25)]",
      bgDesktop: "/assets/customizations/discoPlanet/dp-bg.png",
      bgMobile: "/assets/customizations/discoPlanet/dp-bg.png",
      mainFont: "font-['IBMPlexMono']",
      primaryButton:
        "w-full sm:w-fit !h-[52px] bg-[#414255] border-[2px] border-[#D2D2D2] !px-[22px] !text-sm !leading-[1] font-['DelaGothicOne']  !text-[#F4F5FF] whitespace-nowrap uppercase",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#2B2C41",
      separator: "border-[#8C8FC1] border-t",
      item: "font-['DelaGothicOne'] text-[18px] leading-[18px] h-[40px] sm:justify-start justify-center flex items-center uppercase text-[#2B2C41] !pt-1",
      itemSelected: "bg-[#CDD0F8] text-[#2B2C41]",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles: "font-['DelaGothicOne'] uppercase text-[#414255] text-[20px] leading-[24px] pb-2",
      announcements: {
        customBg: "bg-[#BEC2FF]",
        lg: {
          title: "text-base sm:text-[20px] leading-[1] font-['DelaGothicOne'] mb-1",
          subtitle: "text-[9px] leading-[1] font-bold !text-[#414255]",
        },
        sm: {
          title: "text-base sm:text-[12px] leading-[1] font-['DelaGothicOne'] mb-2",
          subtitle: "text-[9px] leading-[1] font-bold !text-[#414255]",
        },
      },
      event: {
        title: "text-[14px] font-semibold leading-[18px] text-[#414255] font-['IBMPlexMono']",
        subtitle: "text-[14px] leading-[18px] text-[#414255] font-['IBMPlexMono']",
      },
      shop: {
        title: "text-[16px] leading-[1] font-['DelaGothicOne'] text-[#414255] uppercase",
        text: "text-[14px] leading-[18px] text-[#414255]",
        customShopImage: "/assets/customizations/discoPlanet/img_shop.png",
      },
    },
    announcements: {
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[57px]",
      header: "font-['DelaGothicOne'] uppercase text-[#414255] text-[32px] leading-[32px]",
      title: "font-['DelaGothicOne'] uppercase text-[#414255] text-[20px] leading-[24px] pb-2",
      description: "text-[9px] leading-[1] font-bold !text-[#414255]",
    },
    announcement: {
      likeCount: "",
      commentCount: "",
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[23px]",
      title: "font-['DelaGothicOne'] uppercase text-[#414255] text-[20px] leading-[24px] pb-2",
      description: "text-[9px] leading-[1] font-bold !text-[#414255]",
      commentIconColor: "",
      likeIconColor: "",
    },
    event: {
      emptyOrLoadingState: "",
      sectionTitle: "text-[24px] leading-8 font-['DelaGothicOne'] text-[#3C404B] uppercase",
      sectionSubtitle: "text-[14px] leading-[18px] font-semibold text-[#3C404B]",
      text: "text-[14px] leading-[18px] text-[#3C404B] ",
      separator: "border-b border-[#3C404B] border-opacity-40",
      blockContainer: "",
      header: "",
      container: "",
      map: {
        pin: "",
        border: "",
        pinColor: "#3C404B",
        strokeColor: "border-[#3C404B]",
      },
    },
    eventTickets: {
      container: "",
      separator: "",
      event: {
        title: "text-[24px] leading-8 font-['DelaGothicOne'] text-[#3C404B] uppercase",
        subtitle: "text-[14px] leading-[18px] font-semibold text-[#3C404B]",
      },
      ticket: {
        counterContainer: "",
        title: "text-[16px] leading-4 font-['DelaGothicOne'] text-[#3C404B] uppercase",
        description: "text-[12px] leading-3",
        text: "text-[14px] leading-[18px] text-[#3C404B]",
        price: "text-[16px] leading-4 font-['DelaGothicOne'] text-[#3C404B]",
        quantity: "text-[20px] leading-5 font-semibold text-[#3C404B]",
      },
    },
  },
}

export default discoplanet
